module.exports = __webpack_public_path__ + "8ee3aa6a7feaf34c5cc806f645cfd3c6.svg";